export default "__VITE_ASSET__DJ87cCUT__"